import { Controller } from "@hotwired/stimulus"

// This controller is used to manage text filters (with the options contains, is empty and has any value).
export default class extends Controller {
  static get targets() {
    return ["button",
      "selectedContains",
      "selectedIsPresent",
      "selectedIsEmpty",
      "option",
      "containsInput",
      "containsInputWrapper",
      "containsText"]
  }

  static get values() {
    return {
      name: String,
      filter: String,
      // Add context value with default empty string for backward compatibility
      context: { type: String, default: "" }
    }
  }

  connect() {
    this.render()
  }

  open(event) {
    if (event.detail.name === this.nameValue) {
      // The dropdown won't be shown without the timeout
      setTimeout(() => {
        this.buttonTarget.click()
      }, 10)
    }
  }

  apply() {
    this.optionTargets.forEach(option => {
      if (option.checked) {
        this.filterValue = option.value

        if (option.value === "" && this.hasContainsInputTarget) {
          this.filterValue = this.containsInputTarget.value
          if (this.hasContainsTextTarget) {
            this.containsTextTarget.innerText = this.containsInputTarget.value
          }
        }
      }
    })

    this.render()
    this.dispatchFilterEvent()

    if (this.hasButtonTarget) {
      const dropdown = bootstrap.Dropdown.getInstance(this.buttonTarget)
      dropdown.hide()
    }
  }

  clear() {
    let anyChanges = this.filterValue !== "" || (this.hasContainsInputTarget && this.containsInputTarget.value !== "")
    this.filterValue = ""
    this.optionTargets.forEach(option => {
      option.checked = false
    })

    if (this.hasContainsInputTarget) {
      this.containsInputTarget.value = ""
      this.containsInputWrapperTarget.classList.add("d-none")
    }

    this.render()
    if (anyChanges) {
      this.dispatchFilterEvent()
    }
  }

  render() {
    this.optionTargets.forEach(option => {
      if (!this.hasFilterValue) {
        option.checked = false
        return
      }

      if ((option.value === "*" || option.value === "~") && (option.value === this.filterValue)) {
        option.checked = true
      } else if (option.value === "" && this.filterValue !== "" && this.filterValue !== "*" && this.filterValue !== "~") {
        option.checked = true

        // For "contains" filter, we show the input with the value of the filter
        if (option.id.includes("contains")) {
          this.containsInputTarget.value = this.filterValue
          this.containsInputWrapperTarget.classList.remove("d-none")
        }
      }
    })

    if (this.hasSelectedIsPresentTarget) {
      this.selectedIsPresentTarget.classList.add("d-none")
    }
    if (this.hasSelectedIsEmptyTarget) {
      this.selectedIsEmptyTarget.classList.add("d-none")
    }
    if (this.hasSelectedContainsTarget) {
      this.selectedContainsTarget.classList.add("d-none")
    }

    if (this.filterValue !== "") {
      if (this.filterValue === "*") {
        if (this.hasSelectedIsPresentTarget) {
          this.selectedIsPresentTarget.classList.remove("d-none")
        }
      } else if (this.filterValue === "~") {
        if (this.hasSelectedIsEmptyTarget) {
          this.selectedIsEmptyTarget.classList.remove("d-none")
        }
      } else if (this.filterValue !== "") {
        if (this.hasSelectedContainsTarget) {
          this.selectedContainsTarget.classList.remove("d-none")
        }
      }
    }

    if (this.hasButtonTarget) {
      this.buttonTarget.dataset.selectedFilters = "1"
    }
  }

  dispatchFilterEvent() {
    // Create event detail object
    const detail = {
      name: this.nameValue,
      values: this.filterValue
    }

    // Only add context if it's explicitly set (backwards compatibility)
    if (this.contextValue) {
      detail.context = this.contextValue
    }

    this.dispatch("filter", { detail })
  }
}
